// KAL-43: страховка для подбора аналогов ОСБ.
// Подбор аналогов OSB завязан на поля справочника "Толщина осб, мм" (OSB_THICKNESS_MM)
// и "OSB м2" (AREA_OSB). Если у номенклатуры они не заполнены, аналоги не подбираются
// (в частности у безбрендовых позиций). Здесь мы добираем эти значения из названия
// товара, где габариты закодированы как ТОЛЩИНАxШИРИНАxДЛИНА в мм,
// например "Плита OSB-3 (ОСП) 9х1250х2500 мм" -> толщина 9 мм, лист 1250x2500 мм.
// Разделителем может быть кириллическая "х", латинская "x", "*" или "×".

// Три числа подряд через разделитель размеров: толщина x ширина x длина (в мм).
const OSB_DIMENSIONS_RE = /(\d+(?:[.,]\d+)?)\s*[хХxX×*]\s*(\d+(?:[.,]\d+)?)\s*[хХxX×*]\s*(\d+(?:[.,]\d+)?)/;

const toNumber = (value) => {
  if (value === null || value === undefined) return 0;
  const n = parseFloat(String(value).replace(",", "."));
  return Number.isFinite(n) ? n : 0;
};

// Извлекает толщину (мм) и площадь листа (м²) ОСБ-плиты из названия номенклатуры.
// Возвращает { thickness, area }; если распарсить не удалось — нули.
export const parseOsbDimsFromName = (name) => {
  const match = String(name || "").match(OSB_DIMENSIONS_RE);
  if (!match) return { thickness: 0, area: 0 };
  const thickness = toNumber(match[1]);
  const widthMm = toNumber(match[2]);
  const lengthMm = toNumber(match[3]);
  const area = widthMm > 0 && lengthMm > 0 ? (widthMm * lengthMm) / 1000000 : 0;
  return { thickness, area };
};

// Возвращает толщину и площадь ОСБ: приоритет у данных справочника,
// а при их отсутствии — значения, разобранные из названия (страховка KAL-43).
export const resolveOsbDims = (name, data = {}) => {
  const thickness = data && data.OSB_THICKNESS_MM ? toNumber(data.OSB_THICKNESS_MM) : 0;
  const area = data && data.AREA_OSB ? toNumber(data.AREA_OSB) : 0;
  if (thickness > 0 && area > 0) return { thickness, area };
  const fromName = parseOsbDimsFromName(name);
  return {
    thickness: thickness > 0 ? thickness : fromName.thickness,
    area: area > 0 ? area : fromName.area,
  };
};
